import type { ModelKey } from "@/modules/model";
import type { Int } from "@/types";

import { useAtomValue, useSetAtom } from "jotai";

import {
  addItemToAsyncActionsAtom,
  asyncActionsAtom,
  removeItemToAsyncActionsAtom,
} from "./async-actions.state";

export const useAsyncActions = () => {
  const state = useAtomValue(asyncActionsAtom);
  const addItem = useSetAtom(addItemToAsyncActionsAtom);
  const removeItem = useSetAtom(removeItemToAsyncActionsAtom);

  return {
    /**
     * Deleting
     */

    isInDeletingState: (modelKey: ModelKey, id: Int) =>
      (state.deleting[modelKey] ?? []).includes(id),

    setDeletingState: (modelKey: ModelKey, id: Int) =>
      addItem({ type: "deleting", modelKey, id }),

    removeDeletingState: (modelKey: ModelKey, id: Int) =>
      removeItem({ type: "deleting", modelKey, id }),

    /**
     * Updated
     */

    isInUpdatedState: (modelKey: ModelKey, id: Int) =>
      (state.updated[modelKey] ?? []).includes(id),

    setUpdatedState: (modelKey: ModelKey, id: Int) => {
      addItem({ type: "updated", modelKey, id });
      setTimeout(() => {
        removeItem({ type: "updated", modelKey, id });
      }, 1000);
    },

    /**
     * Failed
     */

    isInFailedState: (modelKey: ModelKey, id: Int) =>
      (state.failed[modelKey] ?? []).includes(id),

    setFailedState: (modelKey: ModelKey, id: Int) => {
      addItem({ type: "failed", modelKey, id });
      setTimeout(() => {
        removeItem({ type: "failed", modelKey, id });
      }, 1000);
    },
  };
};
